import OfferService from '../../../../core/services/offer.service'
import { LifecyclePresenter } from '../../../_components/ConnectComponent'
import { dataLayer } from '../../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { ExpiredTableRaw, View } from './ExpiredTable.view'

export class ExpiredTablePresenter implements LifecyclePresenter<View> {
  private view!: ExpiredTableRaw

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    try {
      const offerList = await OfferService.getExpiredOffersList()

      this.view.setInitialValues(offerList.expired, offerList.pagination)
      dataLayer.page.category.applicationStep = 'portal'
      dataLayer.page.category.pageCategory = 'Portal'
    } catch (error) {
      console.log(error)
    }
  }

  getExpiredOffers = async (page: number, pageSize: number) => {
    const expiredList = await OfferService.getExpiredOffersList(page, pageSize)
    return expiredList
  }
}
